import styled from "styled-components";

export const StyledPaymentModal = styled.div`
  .header-section {
    color: red;
  }
`;